import { KeyboardArrowDownRoundedIcon } from '../../icons';
import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiSelect: {
      defaultProps: {
        displayEmpty: true,
        IconComponent: KeyboardArrowDownRoundedIcon,
      },
      styleOverrides: {
        outlined: ({ theme: { unstable_sx: sx } }) => sx({ px: 2, py: 1.25, minHeight: 42 }),
      },
    },
  },
});

export default theme.components;
